import type { JsonSchemaType } from '@gmn-portal/backend';
import type { UseFormReturn } from 'react-hook-form';
import type { z } from 'zod';
import type { Object as PortalObject } from '@/features/shared/objects/types';
import AutoFormObject from '@/shared/components/ui/auto-form/fields/object';

import type { FieldConfig, FieldConfigItem } from '../ui/auto-form/types';

type MetadataAutoFormProps = {
  schema: z.ZodObject<any>;
  form: UseFormReturn<any, any, any>;
  path?: string[];
  disabled?: boolean;
  metadataSchema?: JsonSchemaType;
  groupKey?: string | null;
  disableGrouping?: boolean;
  currentObject?: PortalObject | null;
  canReadObjects?: boolean;
  domain?: 'gmn' | 'customer' | null;
  preview?: boolean;
};

type ExtendedFieldConfigItem = FieldConfigItem & {
  metadataSchema?: JsonSchemaType;
  groupKey?: string | null;
};

export function MetadataAutoForm({
  schema,
  form,
  path,
  disabled,
  metadataSchema,
  groupKey,
  disableGrouping,
  currentObject,
  canReadObjects,
  domain,
  preview,
}: MetadataAutoFormProps) {
  const fieldConfig: FieldConfig<z.infer<typeof schema>> = {
    '*': {
      inputProps: {
        disabled,
      },
      metadataSchema,
      groupKey,
      currentObject,
      canReadObjects,
      domain,
      preview,
    } as ExtendedFieldConfigItem,
  };

  return (
    <AutoFormObject
      schema={schema}
      form={form}
      path={path}
      fieldConfig={fieldConfig}
      metadataSchema={metadataSchema}
      disableGrouping={disableGrouping}
    />
  );
}
